'use strict';
define([], function () {
    function Controller($scope, $state, $stateParams) {
        var name = $state.current.name;
        var section = name.slice(name.lastIndexOf('.') + 1);
        if (section === 'searchConsole') section = 'search-console';
        $scope.selectSection(section);
        if (section === 'spider') {
            $scope.applySpiderRoute($stateParams.category, $stateParams.variant);
        }
        if (section === 'explorer') {
            $scope.applyExplorerRoute($stateParams.filter);
        }
        if (section === 'links') {
            $scope.applyLinkRoute($stateParams.filter);
        }
        if (section === 'structure') {
            $scope.openStructureExplorer();
        }
        if (section === 'search-console') {
            var view = $stateParams.view;
            if ($scope.gscViews.some(function (item) { return item.id === view; })) $scope.selectGscView(view);
        }
        if (section === 'report') {
            $scope.selectReportSection($stateParams.section || 'base');
        }
    }
    Controller.$inject = ['$scope', '$state', '$stateParams'];
    return Controller;
});
